
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";


const PrivacyPolicyPage = () => {

    const { i18n } = useTranslation();
    const nav = useNavigate();

    const currentLanguage = i18n.language;

    return (
        <div className="container mt-4">
            {currentLanguage === 'fi' && (
                <>
                    <a href="#" className="mt-2 mb-2" onClick={() => { nav(`/home`) }}>Takaisin pääsivulle</a>    
                    

                    <h1>
                        Keräämämme ja käsittelemämme henkilötiedot:
                    </h1>

                    <ol>
                        <li>
                            <strong>Henkilötiedot, joita keräämme</strong>
                            <ul>
                                <li>Perustiedot: Nimi, sähköpostiosoite, puhelinnumero, käyttäjätunnus, salasana.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Tietojen käsittelyn tarkoitukset</strong>
                            <ul>
                                <li>Palvelun tarjoaminen: Käytämme henkilötietojasi tarjotaksemme ja ylläpitääksemme sovelluksen toimintoja, kuten käyttäjätilin luomista, kirjautumista ja teknistä tukea.</li>
                                <li>Lakisääteiset velvoitteet: Käsittelemme tietoja lakisääteisten velvoitteiden, kuten kirjanpito- tai tietosuoja-asetusten, täyttämiseksi.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Tietojen jakaminen kolmansille osapuolille</strong>
                            <ul>
                                <li>Palveluntarjoajat: Voimme käyttää kolmansia osapuolia tietojen käsittelyyn (esim. pilvipalvelut, maksupalvelut). Nämä toimijat käsittelevät tietoja meidän lukuumme ja ainoastaan sovittuja tarkoituksia varten.</li>
                                <li>Lakisääteiset vaatimukset: Saatamme jakaa henkilötietojasi, jos laki tai viranomaiset niin edellyttävät (esim. petoksen estämiseksi tai oikeudellisten vaatimusten vuoksi).</li>
                                <li>Yritysjärjestelyt: Jos yrityksemme käy läpi fuusion, yrityskaupan tai varallisuuden myynnin, henkilötietosi voivat siirtyä uudelle omistajalle.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Tietojen säilytys</strong>
                            <ul>
                                <li>Säilytämme henkilötietojasi niin kauan kuin on tarpeen yllä kuvattujen tarkoitusten toteuttamiseksi tai niin kauan kuin laki edellyttää. Kun tietoja ei enää tarvita, poistamme tai anonymisoimme ne asianmukaisesti.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Käyttäjän oikeudet</strong>
                            <ul>
                                <li>Pääsy tietoihin: Voit pyytää kopiota henkilötiedoistasi, joita käsittelemme.</li>
                                <li>Tietojen oikaisu: Voit pyytää virheellisten tai puutteellisten tietojen korjaamista.</li>
                                <li>Tietojen poistaminen: Voit pyytää henkilötietojesi poistamista (oikeus tulla unohdetuksi).</li>
                                <li>Käsittelyn rajoittaminen: Voit pyytää tietojesi käsittelyn rajoittamista tietyissä tilanteissa.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Tietoturva</strong>
                            <ul>
                                <li>Käytämme asianmukaisia teknisiä ja organisatorisia toimenpiteitä suojataksemme henkilötietojasi luvattomalta pääsyltä, väärinkäytöltä tai menetykseltä. Vaikka pyrimme parhaamme mukaan suojaamaan tietojasi, mikään järjestelmä ei ole täysin turvallinen, ja suosittelemme ottamaan varovaisuutta henkilötietojen suojaamisessa.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Tietojen siirto EU/ETA-alueen ulkopuolelle</strong>
                            <ul>
                                <li>Emme siirrä henkilötietojasi EU/ETA-alueen ulkopuolelle ilman riittäviä suojatoimenpiteitä. Jos siirto on tarpeen, noudatamme GDPR-vaatimuksia tietojen siirrosta.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Tietosuojaselosteen muutokset</strong>
                            <ul>
                                <li>Saatamme päivittää tätä tietosuojaselostetta aika ajoin. Ilmoitamme merkittävistä muutoksista sovelluksessa tai sähköpostitse.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Yhteystiedot</strong>
                            <ul>
                                <li style={{ listStyleType: "none" }}>
                                    <p>Vitec Codea</p>
                                    <p>Maistraatinportti 1, 00240 Helsinki</p>
                                    <p>codea.asiakaspalvelu@vitecsoftware.com</p>
                                    <p>+358 401732414</p>
                                </li>
                            </ul>
                        </li>

                    </ol>
                </>)}

            {currentLanguage === 'en' && (
                <>
                    <a href="#" className="mt-2 mb-2" onClick={() => { nav(`/home`) }}>Back to main page</a>  

                    <h1>
                        Personal data we collect and process:
                    </h1>

                    <ol>
                        <li>
                            <strong>Personal data we collect</strong>
                            <ul>
                                <li>Basic information: Name, email address, phone number, username, password.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Purposes of data processing</strong>
                            <ul>
                                <li>Service provision: We use your personal data to provide and maintain app functionalities, such as creating a user account, login, and technical support.</li>
                                <li>Legal obligations: We process data to comply with legal requirements, such as accounting or data protection regulations.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Sharing data with third parties</strong>
                            <ul>
                                <li>Service providers: We may use third parties to process data (e.g., cloud services, payment services). These entities process data on our behalf and only for agreed purposes.</li>
                                <li>Legal requirements: We may share your personal data if required by law or authorities (e.g., to prevent fraud or for legal obligations).</li>
                                <li>Corporate arrangements: If our company undergoes a merger, acquisition, or asset sale, your personal data may be transferred to the new owner.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Data retention</strong>
                            <ul>
                                <li>We retain your personal data for as long as necessary to fulfill the purposes described above or as long as legally required. When data is no longer needed, we will delete or anonymize it appropriately.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>User rights</strong>
                            <ul>
                                <li>Access to data: You may request a copy of the personal data we process about you.</li>
                                <li>Data correction: You may request the correction of incorrect or incomplete data.</li>
                                <li>Data deletion: You may request the deletion of your personal data (right to be forgotten).</li>
                                <li>Restriction of processing: You may request the restriction of data processing in certain situations.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Data security</strong>
                            <ul>
                                <li>We use appropriate technical and organizational measures to protect your personal data from unauthorized access, misuse, or loss. While we strive to protect your data, no system is completely secure, and we recommend exercising caution in protecting your personal information.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Data transfer outside the EU/EEA</strong>
                            <ul>
                                <li>We do not transfer your personal data outside the EU/EEA without adequate safeguards. If such a transfer is necessary, we will comply with GDPR requirements for data transfers.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Changes to the privacy policy</strong>
                            <ul>
                                <li>We may update this privacy policy from time to time. We will notify you of significant changes in the app or via email.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>Contact information</strong>
                            <ul>
                                <li style={{ listStyleType: "none" }}>
                                    <p>Vitec Codea</p>
                                    <p>Maistraatinportti 1, 00240 Helsinki</p>
                                    <p>codea.asiakaspalvelu@vitecsoftware.com</p>
                                    <p>+358 401732414</p>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </>)}
        </div>
    )
}

export default PrivacyPolicyPage;